import React from 'react';
import { Mail, Phone, Send, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';

const ContactForm = () => {
  return (
    <section id="contact" className="py-20 md:py-32 bg-gradient-to-b from-white to-amber-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Let's Plan Your Perfect Event
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">

          {/* LEFT SIDE */}
          <div className="space-y-6">

            <div className="flex gap-3">
              <Phone />
              <a href="tel:+919638063350">+91 96380 63350</a>
            </div>

            <div className="flex gap-3">
              <MessageCircle />
              <a
                href="https://wa.me/919638063350?text=Hi%20I%20saw%20your%20website%20and%20want%20to%20plan%20an%20event"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Us
              </a>
            </div>

            <div className="flex gap-3">
              <Mail />
              <a href="mailto:Singhanant198@gmail.com">
                Singhanant198@gmail.com
              </a>
            </div>

          </div>

          {/* FORM */}
          <div className="bg-white rounded-2xl shadow-xl p-8">

            <form 
              action="https://formsubmit.co/Singhanant198@gmail.com" 
              method="POST" 
              className="space-y-6"
            >

              {/* Hidden Fields */}
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_subject" value="New Event Enquiry - Made in Heaven" />
              <input type="hidden" name="_autoresponse" value="Thanks for contacting Made in Heaven. We will contact you shortly." />
              <input type="hidden" name="_next" value="https://new-made-in-heavens.vercel.app/" />

              {/* Inputs */}
              <Input name="name" placeholder="Full Name" required />
              <Input name="email" type="email" placeholder="Email" required />
              <Input name="phone" placeholder="Phone" required />
              <Input name="event_type" placeholder="Event Type" />
              <Input name="event_date" type="date" />
              <Input name="location" placeholder="Location" />
              <Input name="budget" placeholder="Budget" />
              <Textarea name="message" placeholder="Tell us about your event..." required />

              <Button type="submit" className="w-full">
                <Send className="mr-2 h-4 w-4" />
                Send Message
              </Button>

            </form>

          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;
